<div class="container m-b-20 layout-row layout-lt-md-column align-end gap-2percent">
  <span *LOSxHasPermission="'CREATE_GLACCOUNT'">
    @if (glAccount.usage.value === 'HEADER') {
      <button
        mat-raised-button
        color="primary"
        [routerLink]="['/accounting/chart-of-accounts/gl-accounts/create']"
        [queryParams]="{ parent: glAccount.id, accountType: glAccount.type.id }"
      >
        <fa-icon icon="plus" class="m-r-10"></fa-icon>
        {{ 'labels.buttons.Subledger Account' | translate }}
      </button>
    }
  </span>

  <span *LOSxHasPermission="'UPDATE_GLACCOUNT'">
    <button mat-raised-button color="primary" [routerLink]="['edit']">
      <fa-icon icon="edit" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Edit' | translate }}
    </button>
  </span>

  <span *LOSxHasPermission="'UPDATE_GLACCOUNT'">
    @if (!glAccount.disabled) {
      <button mat-raised-button color="warn" (click)="changeGlAccountState()">
        <fa-icon icon="lock" class="m-r-10"></fa-icon>
        {{ 'labels.buttons.Disable' | translate }}
      </button>
    }
  </span>

  <span *LOSxHasPermission="'UPDATE_GLACCOUNT'">
    @if (glAccount.disabled) {
      <button mat-raised-button color="accent" (click)="changeGlAccountState()">
        <fa-icon icon="lock-open" class="m-r-10"></fa-icon>
        {{ 'labels.buttons.Enable' | translate }}
      </button>
    }
  </span>

  <button mat-raised-button color="warn" (click)="deleteGlAccount()" *LOSxHasPermission="'DELETE_GLACCOUNT'">
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

<!-- GL Account Details -->
<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="content-rows">
        <div class="content-row">
          <div class="label">{{ 'labels.inputs.Account Type' | translate }}</div>
          <div class="value">{{ 'labels.inputs.accounting.' + glAccount.type?.value | translate }}</div>
        </div>

        <div class="content-row">
          <div class="label">{{ 'labels.inputs.GL Code' | translate }}</div>
          <div class="value">{{ glAccount.glCode }}</div>
        </div>

        @if (glAccount.parent) {
          <div class="content-row">
            <div class="label">{{ 'labels.inputs.Parent Account Name' | translate }}</div>
            <div class="value">
              <a
                class="tab-link"
                [routerLink]="['/accounting/chart-of-accounts/gl-accounts/view/' + glAccount.parent.id]"
              >
                <LOSx-gl-account-display [glAccount]="glAccount.parent"></LOSx-gl-account-display>
              </a>
            </div>
          </div>
        }

        @if (glAccount.tagId.id) {
          <div class="content-row">
            <div class="label">{{ 'labels.inputs.Tag' | translate }}</div>
            <div class="value">{{ glAccount.tagId.name }}</div>
          </div>
        }

        <div class="content-row">
          <div class="label">{{ 'labels.inputs.Account Usage' | translate }}</div>
          <div class="value">{{ glAccount.usage?.value }}</div>
        </div>

        <div class="content-row">
          <div class="label">{{ 'labels.inputs.Manual Entries Allowed' | translate }}</div>
          <div class="value">{{ glAccount.manualEntriesAllowed | yesNo }}</div>
        </div>

        @if (glAccount.description) {
          <div class="content-row">
            <div class="label">{{ 'labels.inputs.Description' | translate }}</div>
            <div class="value">{{ glAccount.description }}</div>
          </div>
        }
      </div>
    </mat-card-content>

    <mat-card-actions class="layout-row align-center gap-5px responsive-column">
      <button type="button" color="primary" mat-raised-button (click)="goBack()">
        {{ 'labels.buttons.Back' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</div>
